export default "__VITE_ASSET__f9L6QfTM__";